"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSearchQueryParams = exports.setInstanceId = exports.setError = exports.sendTags = exports.resetCustomerSearchError = exports.resetCustomerSearch = exports.getImpersonationTokenSuccess = exports.getImpersonationTokenFailure = exports.getImpersonationToken = exports.getCustomerSearchDataSuccess = exports.getCustomerSearchDataFailure = exports.getCustomerSearchData = exports.defaultBillingAddressChanged = exports.UPDATE_CUSTOMER_INFO_SUCCESS = exports.SET_SEARCH_QUERY_PARAMS = exports.SET_INSTANCE_ID = exports.SET_ERROR = exports.SEND_TAGS = exports.RESET_CUSTOMER_SEARCH_ERROR = exports.RESET_CUSTOMER_SEARCH_DATA = exports.LOGOUT = exports.GET_IMPERSONATION_TOKEN_SUCCESS = exports.GET_IMPERSONATION_TOKEN_FAILURE = exports.GET_IMPERSONATION_TOKEN = exports.GET_CUSTOMER_SEARCH_DATA_SUCCESS = exports.GET_CUSTOMER_SEARCH_DATA_REQUEST = exports.GET_CUSTOMER_SEARCH_DATA_FAILURE = exports.DEFAULT_BILLING_ADDRESS_CHANGE = void 0;

var _appConstants = require("../constants/appConstants");

//Search for customers action types
var GET_CUSTOMER_SEARCH_DATA_REQUEST = "@".concat(_appConstants.pkgName, "/GET_CUSTOMER_SEARCH_DATA_REQUEST");
exports.GET_CUSTOMER_SEARCH_DATA_REQUEST = GET_CUSTOMER_SEARCH_DATA_REQUEST;
var RESET_CUSTOMER_SEARCH_DATA = "@".concat(_appConstants.pkgName, "/RESET_CUSTOMER_SEARCH_DATA");
exports.RESET_CUSTOMER_SEARCH_DATA = RESET_CUSTOMER_SEARCH_DATA;
var RESET_CUSTOMER_SEARCH_ERROR = "@".concat(_appConstants.pkgName, "/RESET_CUSTOMER_SEARCH_ERROR");
exports.RESET_CUSTOMER_SEARCH_ERROR = RESET_CUSTOMER_SEARCH_ERROR;
var GET_CUSTOMER_SEARCH_DATA_SUCCESS = "@".concat(_appConstants.pkgName, "/GET_CUSTOMER_SEARCH_DATA_SUCCESS");
exports.GET_CUSTOMER_SEARCH_DATA_SUCCESS = GET_CUSTOMER_SEARCH_DATA_SUCCESS;
var GET_CUSTOMER_SEARCH_DATA_FAILURE = "@".concat(_appConstants.pkgName, "/GET_CUSTOMER_SEARCH_DATA_FAILURE"); // get impersonation token action types

exports.GET_CUSTOMER_SEARCH_DATA_FAILURE = GET_CUSTOMER_SEARCH_DATA_FAILURE;
var GET_IMPERSONATION_TOKEN = '@ikkiImpersonation/GET_IMPERSONATION_TOKEN';
exports.GET_IMPERSONATION_TOKEN = GET_IMPERSONATION_TOKEN;
var GET_IMPERSONATION_TOKEN_SUCCESS = "@ikkiImpersonation/GET_IMPERSONATION_TOKEN_SUCCESS";
exports.GET_IMPERSONATION_TOKEN_SUCCESS = GET_IMPERSONATION_TOKEN_SUCCESS;
var GET_IMPERSONATION_TOKEN_FAILURE = "@ikkiImpersonation/GET_IMPERSONATION_TOKEN_FAILURE";
exports.GET_IMPERSONATION_TOKEN_FAILURE = GET_IMPERSONATION_TOKEN_FAILURE;
var SET_INSTANCE_ID = "@".concat(_appConstants.pkgName, "/SET_INSTANCE_ID");
exports.SET_INSTANCE_ID = SET_INSTANCE_ID;
var UPDATE_CUSTOMER_INFO_SUCCESS = "@".concat(_appConstants.customerDetailsWidget, "/UPDATE_CUSTOMER_INFO_SUCCESS");
exports.UPDATE_CUSTOMER_INFO_SUCCESS = UPDATE_CUSTOMER_INFO_SUCCESS;
var DEFAULT_BILLING_ADDRESS_CHANGE = "@".concat(_appConstants.pkgName, "/DEFAULT_BILLING_ADDRESS_CHANGE");
exports.DEFAULT_BILLING_ADDRESS_CHANGE = DEFAULT_BILLING_ADDRESS_CHANGE;
var SET_SEARCH_QUERY_PARAMS = "@".concat(_appConstants.pkgName, "/SET_SEARCH_QUERY_PARAMS");
exports.SET_SEARCH_QUERY_PARAMS = SET_SEARCH_QUERY_PARAMS;
var LOGOUT = 'LOGOUT';
exports.LOGOUT = LOGOUT;
var SET_ERROR = 'SET_ERROR'; // tealium 

exports.SET_ERROR = SET_ERROR;
var SEND_TAGS = "SEND_TAGS"; //Search for customers action creators

exports.SEND_TAGS = SEND_TAGS;

var getCustomerSearchData = function getCustomerSearchData(data) {
  return {
    type: GET_CUSTOMER_SEARCH_DATA_REQUEST,
    payload: data
  };
};

exports.getCustomerSearchData = getCustomerSearchData;

var getCustomerSearchDataSuccess = function getCustomerSearchDataSuccess(response) {
  return {
    type: GET_CUSTOMER_SEARCH_DATA_SUCCESS,
    payload: response
  };
};

exports.getCustomerSearchDataSuccess = getCustomerSearchDataSuccess;

var getCustomerSearchDataFailure = function getCustomerSearchDataFailure(error) {
  return {
    type: GET_CUSTOMER_SEARCH_DATA_FAILURE,
    payload: error
  };
};

exports.getCustomerSearchDataFailure = getCustomerSearchDataFailure;

var getImpersonationToken = function getImpersonationToken(imppersonationPayload) {
  return {
    type: GET_IMPERSONATION_TOKEN,
    payload: imppersonationPayload
  };
};

exports.getImpersonationToken = getImpersonationToken;

var getImpersonationTokenSuccess = function getImpersonationTokenSuccess(impersonationToken) {
  return {
    type: GET_IMPERSONATION_TOKEN_SUCCESS,
    payload: impersonationToken
  };
};

exports.getImpersonationTokenSuccess = getImpersonationTokenSuccess;

var getImpersonationTokenFailure = function getImpersonationTokenFailure(error) {
  return {
    type: GET_IMPERSONATION_TOKEN_FAILURE,
    payload: error
  };
};

exports.getImpersonationTokenFailure = getImpersonationTokenFailure;

var resetCustomerSearch = function resetCustomerSearch() {
  return {
    type: RESET_CUSTOMER_SEARCH_DATA,
    payload: false
  };
};

exports.resetCustomerSearch = resetCustomerSearch;

var resetCustomerSearchError = function resetCustomerSearchError() {
  return {
    type: RESET_CUSTOMER_SEARCH_ERROR
  };
};

exports.resetCustomerSearchError = resetCustomerSearchError;

var defaultBillingAddressChanged = function defaultBillingAddressChanged(billingAddress) {
  return {
    type: DEFAULT_BILLING_ADDRESS_CHANGE,
    payload: billingAddress
  };
};

exports.defaultBillingAddressChanged = defaultBillingAddressChanged;

var setInstanceId = function setInstanceId(instanceId) {
  return {
    type: SET_INSTANCE_ID,
    payload: instanceId
  };
};

exports.setInstanceId = setInstanceId;

var setSearchQueryParams = function setSearchQueryParams(queryParamWithId) {
  return {
    type: SET_SEARCH_QUERY_PARAMS,
    payload: queryParamWithId
  };
};

exports.setSearchQueryParams = setSearchQueryParams;

var setError = function setError(errorStatusCode, retryAction) {
  return {
    type: SET_ERROR,
    payload: {
      errorStatusCode: errorStatusCode,
      retryAction: retryAction
    }
  };
};

exports.setError = setError;

var sendTags = function sendTags(payload) {
  return {
    type: SEND_TAGS,
    payload: payload
  };
};

exports.sendTags = sendTags;